<template>
    <div v-if="chartData.datasets.length > 0">
        <div class="card">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-primary">Receita x Despesas durante o ano</h6>
                <select class="form-control select-graph" v-model="year" @change="changeYearFilter">
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                </select>
            </div>
            <div class="card-body card-body-no-spaccing">
                <div class="row">
                    <div class="col-xl-12 col-md-12 col-sm-12">
                        <Bar :data="chartData" :options="chartOptions" :style="style" />
                    </div>
                </div>
            </div>
        </div>


    </div>
    <div v-else>
        Carregando dados...
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
} from 'chart.js'
import { Bar } from 'vue-chartjs'
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const year = ref(2026);

const chartData = ref({
    labels: [],
    datasets: []
});

const chartOptions = ref({
    responsive: true,
    maintainAspectRatio: false
});

const style = ref({
    height: '336px', // Set your desired height here
    width: '100%',
    position: 'relative',
});


const changeYearFilter = () => {
    loadData();
};



onMounted(async () => {
    loadData();
});

const loadData = async () => {
    try {
        const response = await api.get('/dashboard-financial/annualChartReceivablePayable', { params: { 'year': year.value } }).then((response) => { return response; }).catch((error) => { handleRequestErrors(error.status) });
        const apiData = response.data.data;
        chartData.value = {
            labels: apiData.labels,
            datasets: [
                {
                    label: 'Receitas',
                    borderColor: 'rgba(1,97,38, 0.8)',
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(1,97,38, 0.3)',
                    data: apiData.receivable
                },
                {
                    label: 'Despesas',
                    borderColor: 'rgba(128,3,3, 0.8)',
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(128,3,3, 0.3)',
                    data: apiData.payable
                }
            ]
        };
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};

</script>